import { all, put, select, takeEvery } from 'redux-saga/effects';

import { hateoas } from '../../lib/links';
import * as actions from './actions';
import * as constants from './constants';
import * as entityNormalizers from '../../entities/Entity/normalizers';
import * as entityActions from '../../entities/Entity/actions';
import { apiCall, Mappings, Endpoints } from '../../lib/LeanLinkService';
import { request, success, failure } from '../../lib/Actions';
import * as customerSelectors from '../../entities/Customer/selectors';
import * as paginatedItemsActions from '../../entities/PaginatedItems/actions';

function* updateRequested({ payload: { id, form, values } }) {
  yield apiCall(
    Mappings.patch({ url: Endpoints.customers.get({ id }), payload: values }),
    data => success(actions.UPDATE, { id, form })(entityNormalizers.entity(data)),
    failure(actions.UPDATE, { id, form }),
  );
}

function* refreshDependencies({ payload: { id } }) {
  const customer = yield select(customerSelectors.customerById, id);
  const links = customer.links.toJS();
  yield put(request(paginatedItemsActions.FETCH)({ url: hateoas(links).get('events') }));
}

function shouldTimelineRefresh(action) {
  // Customer related
  if (action.type === actions.UPDATE.SUCCESS) {
    return true;
  }

  if ([entityActions.PATCH.SUCCESS, entityActions.CREATE.SUCCESS].includes(action.type)
    && [constants.CUSTOMER_TASK_FORM].includes(action.payload.form)) {
    return true;
  }

  return false;
}

export default function* defaultSaga() {
  yield all([
    takeEvery(actions.UPDATE.REQUEST, updateRequested),
    takeEvery(shouldTimelineRefresh, refreshDependencies),
  ]);
}
